/*
 * PanamaJack — Oculta el botón flotante de filtro de colección al llegar al footer.
 * Extraído de theme.js durante el rebase a Showcase 10.2.0 (iso-funcional).
 * Vanilla JS, sin dependencias. Carga con defer desde layout/theme.liquid.
 */
(function () {
  function init() {
    var footer = document.getElementById("shopify-section-footer");
    var boton = document.querySelector(".boton_filtro_coleccion");
    if (footer && boton) {
      new IntersectionObserver(function (entries) {
        boton.parentElement.classList.toggle("-out", entries[0].isIntersecting);
      }).observe(footer);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
